
import React, { useEffect, useState } from "react";
import "./Procced_to_payment.css";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { VerifyCoupon, resetCouponVerifyState } from "../../../../features/admin/coupon_verify/slice";
import { vendorSubscription } from "../../../../features/admin/VendorSubscription/slice";


function Procced_to_payment({ nextStep, prevStep, selectedPlan, userId }) {

  const dispatch = useDispatch();


  const handleGoBack = () => {
   const  res=dispatch(resetCouponVerifyState());
  console.log("resssssssssssssssssssssss",res)
    prevStep();
  };

  const { loading, success, data, error } = useSelector(
    (state) => state.couponVerify
  );

  console.log("datadatadatadatadatadata", data);

  const [coupon, setCoupon] = useState("");
  const [finalPrice, setFinalPrice] = useState(selectedPlan?.final_price);

  console.log("FinalPrice", finalPrice);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // 🔹 Handle coupon verify response
useEffect(() => {
  if (success && data) {
    if (data.success === true) {

      setFinalPrice(data.data.final_amount);

    } else {
      alert(data?.message || "Invalid coupon code");
    }
  }

  if (error) {
    alert(error?.message || "Invalid coupon");
  }
}, [success, data, error]);


  const applyCoupon = async () => {
    if (!coupon) {
      alert("Please enter a coupon code");
      return;
    }

    await dispatch(
      VerifyCoupon({
        user_id: userId, 
        coupon_code: coupon,
        subscription_id: selectedPlan.id,
      })
    );
  };


  const vendorSubscriptionfun = async (razorpay_payment_id) => {

    const taxRate = 0.18;

    const amountWithTax = Number(finalPrice) + (Number(finalPrice) * Number(taxRate));

    const data = {
      razorpay_payment_id: razorpay_payment_id,
      amount: amountWithTax,
      user_id: userId,
      subscription_id: selectedPlan.id,
    }

    console.log("data", data);

    const res=await dispatch(vendorSubscription(data));
  };




  const openRazorpay = () => {
   const taxRate = 0.18;

    const amountWithTax = Number(finalPrice) + (Number(finalPrice) * Number(taxRate));
    const amountInPaise = Math.round(amountWithTax * 100);

    console.log(amountInPaise,'amountInPaise');
    

    const options = {
      // key: "rzp_test_I05KCFb1v5JJRc",
      key: "rzp_live_TWKUgV5UUBOwqM",
      amount: amountInPaise,
      currency: "INR",
      name: "My MDS",
      description: "Test Transaction",
      image: "/assets/images/logo/logo.png",
      handler: function (response) {


        vendorSubscriptionfun(response.razorpay_payment_id)
        console.log("Payment Successful!", response);
        alert("Payment successful! Payment ID: " + response.razorpay_payment_id);
        nextStep();
      },
      prefill: {
        name: "Test User",
        email: "testuser@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();

    rzp1.on("payment.failed", function (response) {
      console.error("Payment Failed:", response.error);
      alert("Payment failed. Please try again.");
    });
  };

  if (!selectedPlan) {
    return <div>Loading selected plan...</div>;
  }

  return (
    <>
      <section className="Procced_to_payment Subscription_Plan_card_holder">
        <div className="stepform_form">
          <div className="field_holder ">
            <InputGroup className="mb-3">
              <Form.Control
                placeholder="Enter a coupon code here"
                value={coupon}
                onChange={(e) => { setCoupon(e.target.value); setFinalPrice(selectedPlan?.final_price); }}
              />
              <InputGroup.Text>
                <Button
                  className="apply_btn"
                  type="button"
                  onClick={applyCoupon}
                  disabled={loading}

                  onChan
                >
                  {loading ? "Applying..." : "Apply"}
                </Button>
              </InputGroup.Text>
            </InputGroup>
          </div>

          <div className="subscription_plan_holder">
            <section className="Subscription_Plan_card active">
              <div className="heading_text">
                <div className="price_holder">
                  <p>{selectedPlan.name}</p>
                  <span class="final-price">₹. {finalPrice} {finalPrice != 0 && (<sub>+(18% GST)</sub>)}</span>
                </div>
              </div>
              <div className="info_holder">
                <div className="duration_holder flex_box">
                  <h3>Duration:</h3>
                  <p>
                    {selectedPlan.validity} <br /> <sub>(1 hour daily)</sub>
                  </p>
                </div>
                <div className="duration_holder">
                  <h3>Features:</h3>
                  <ul>
                    {selectedPlan.features?.map((item, index) => (
                      <li
                        key={index}
                        dangerouslySetInnerHTML={{ __html: item }}
                      />
                    ))}
                  </ul>
                </div>
              </div>
            </section>
          </div>

          <div className="buttons">
            <Button className="back_btn form_btn mt-4" onClick={handleGoBack} >
              Back
            </Button>
            <Button
              className="search_btn form_btn mt-4"
              onClick={openRazorpay}
            >
              Proceed to Payment
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}

export default Procced_to_payment;





















// import React, { useEffect } from "react";
// import "./Procced_to_payment.css";
// import { Button, Form, InputGroup } from "react-bootstrap";

// function Procced_to_payment({ nextStep, prevStep, selectedPlan }) {


//   console.log("selectedPlan in Proceed to payment:", selectedPlan);
//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.async = true;
//     document.body.appendChild(script);
//   }, []);

//   const openRazorpay = () => {
//     const amountInPaise = selectedPlan.price * 100;

//     const options = {
//       key: "rzp_test_I05KCFb1v5JJRc", // Your Razorpay test key
//       amount: amountInPaise,
//       currency: "INR",
//       name: "My MDS",
//       description: "Test Transaction",
//       image: "/assets/images/logo/logo.png",
//       handler: function (response) {
//         console.log("Payment Successful!", response);
//         alert("Payment successful! Payment ID: " + response.razorpay_payment_id);
//         nextStep(); // Move to Congratulations step
//       },
//       prefill: {
//         name: "Test User",
//         email: "testuser@example.com",
//         contact: "9999999999",
//       },
//       notes: {
//         address: "Razorpay Corporate Office",
//       },
//       theme: {
//         color: "#052c65",
//       },
//     };

//     const rzp1 = new window.Razorpay(options);
//     rzp1.open();

//     rzp1.on("payment.failed", function (response) {
//       console.error("Payment Failed:", response.error);
//       alert("Payment failed. Please try again.");
//     });
//   };


// if (!selectedPlan) {
//   return <div>Loading selected plan...</div>;
// }
//   return (
//     <>
//       <section className="Procced_to_payment Subscription_Plan_card_holder">
//         <div className="stepform_form">
//           <div className="field_holder ">
//             <InputGroup className="mb-3">
//               <Form.Control
//                 placeholder="Enter a coupon code here"
//               />
//               <InputGroup.Text ><Button className='apply_btn' type="button">Apply</Button></InputGroup.Text>
//             </InputGroup>
//           </div>

//           <div className="subscription_plan_holder">
//             <section className="Subscription_Plan_card active">
//               <div className="heading_text">
//                 <div className="price_holder">
//                   <p>{selectedPlan.title}</p>
//                   <h3>₹. {selectedPlan.price}</h3>
//                 </div>
//               </div>
//               <div className="info_holder">
//                 <div className="duration_holder flex_box">
//                   <h3>Duration:</h3>
//                   <p>
//                     {selectedPlan.validity} <br /> <sub>(1 hour daily)</sub>
//                   </p>
//                 </div>
//                 <div className="duration_holder">
//                   <h3>Features:</h3>
//                   <ul>
//                     {selectedPlan.features?.map((item, index) => (
//                       <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             </section>
//           </div>

//           <div className="buttons">
//             <Button className="back_btn form_btn mt-4" onClick={prevStep}>
//               Back
//             </Button>
//             <Button className="search_btn form_btn mt-4" onClick={openRazorpay}>
//               Proceed to Payment
//             </Button>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }

// export default Procced_to_payment;
